import {Box, type SxProp} from '@primer/react'
import {clsx} from 'clsx'
import {type ComponentPropsWithoutRef, forwardRef} from 'react'

import styles from './styled-group-header.module.css'

export const GROUP_HEADER_HEIGHT = 44

export const StyledGroupHeader = forwardRef<
  HTMLDivElement,
  ComponentPropsWithoutRef<'div'> & SxProp & {topOffset?: number}
>(({topOffset, style, children, className, sx, ...props}, ref) => {
  return (
    <Box
      ref={ref}
      sx={sx}
      style={{top: topOffset ?? 0, height: `${GROUP_HEADER_HEIGHT}px`, ...style}}
      className={clsx(styles.styledGroupHeaderWrapper, className)}
      {...props}
    >
      {children}
    </Box>
  )
})

StyledGroupHeader.displayName = 'StyledGroupHeader'
